import React from 'react';
import { Outlet } from 'react-router-dom';

/** Sol menü ile admin içeriği arasındaki çerçeve boşluğu */
const AdminPageLayout: React.FC = () => (
  <div className="p-8">
    <Outlet />
  </div>
);

export default AdminPageLayout;
